<script setup lang="ts">
import PdfFile from './icons/pdf-one.svg';
import PdfPrint from './icons/printer.svg';
import { defineProps, computed } from 'vue';
import {historyDocumentPdfUrl} from "capitalist-shared/src/finance/documents";
import { getCurrentInstance } from 'vue';

const props = defineProps({
  id: {
    required: true
  }
})

const documentId = computed(() => Number(props.id));

const locale = computed(() => {
  return getCurrentInstance()?.proxy?.$i18n?.locale || 'en';
})

const printUrl = computed(() => {
  return historyDocumentPdfUrl(documentId.value as number, false, locale.value);
})

const downloadUrl = computed(() => {
  return historyDocumentPdfUrl(documentId.value as number, true, locale.value);
})
</script>

<template>
<div class="document-details-printer-panel">
  <div>
    <a :href="downloadUrl">
      <img :src="PdfFile" alt="Download PDF" />
      {{$t('Скачать PDF')}}
    </a>
  </div>
  <div>
    <a :href="printUrl" target="_blank">
      <img :src="PdfPrint" alt="Print PDF" />
      {{$t('Распечатать')}}
    </a>
  </div>
</div>
</template>

<style scoped lang="less">
.document-details-printer-panel {
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  align-items: center;
  gap: 30px;
  a {
    display: flex;
    align-items: center;
    gap: 10px;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "Печать PDF документа": "Print PDF document",
    "Скачать PDF документ": "Download PDF document",
    "Распечатать": "Print",
    "Скачать PDF": "Download PDF"
  }
}
</i18n>
